import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { COUNTRY_CODES } from '../../data/countryCodes';

export const Step5Contact = ({ formData, updateFormData, errFor, tr }) => (
  <div className="space-y-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">{tr('wizard.step5.title')}</h2>
    <p className="text-gray-600 mb-6">{tr('wizard.step5.intro')}</p>

    <div>
      <Label htmlFor="fullName" className="text-base font-semibold">{tr('wizard.step5.fullName')}</Label>
      <Input
        id="fullName"
        placeholder={tr('wizard.step5.fullNamePlaceholder')}
        value={formData.fullName}
        onChange={(e) => updateFormData('fullName', e.target.value)}
        className="mt-2"
        required
      />
      {errFor('fullName')}
    </div>

    <div>
      <Label htmlFor="email" className="text-base font-semibold">{tr('wizard.step5.email')}</Label>
      <Input
        id="email"
        type="email"
        placeholder={tr('wizard.step5.emailPlaceholder')}
        value={formData.email}
        onChange={(e) => updateFormData('email', e.target.value)}
        className="mt-2"
        required
      />
      {errFor('email')}
    </div>

    <div>
      <Label className="text-base font-semibold">{tr('wizard.step5.phone')}</Label>
      <div className="grid grid-cols-1 sm:grid-cols-[170px_1fr] gap-2 mt-2">
        <Select
          value={formData.phoneCountryCode}
          onValueChange={(value) => updateFormData('phoneCountryCode', value)}
        >
          <SelectTrigger data-testid="phone-country-code-select">
            <SelectValue placeholder={tr('wizard.common.countryCode')} />
          </SelectTrigger>
          <SelectContent>
            {COUNTRY_CODES.map((c) => (
              <SelectItem key={`${c.code}-${c.country}`} value={c.code}>
                {c.country} {c.code}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          id="phone"
          type="tel"
          placeholder={tr('wizard.step5.phonePlaceholder')}
          value={formData.phone}
          onChange={(e) => updateFormData('phone', e.target.value)}
          required
        />
      </div>
      {errFor('phoneCountryCode')}
      {errFor('phone')}
    </div>

    <div>
      <Label htmlFor="country" className="text-base font-semibold">{tr('wizard.step5.country')}</Label>
      <Input
        id="country"
        placeholder={tr('wizard.step5.countryPlaceholder')}
        value={formData.country}
        onChange={(e) => updateFormData('country', e.target.value)}
        className="mt-2"
        required
      />
      {errFor('country')}
    </div>

    <div>
      <Label htmlFor="preferredLanguage" className="text-base font-semibold">{tr('wizard.step5.preferredLang')}</Label>
      <Select
        value={formData.preferredLanguage}
        onValueChange={(value) => updateFormData('preferredLanguage', value)}
      >
        <SelectTrigger className="mt-2">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="English">{tr('wizard.step5.langEnglish')}</SelectItem>
          <SelectItem value="Spanish">{tr('wizard.step5.langSpanish')}</SelectItem>
          <SelectItem value="Other">{tr('wizard.step5.langOther')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
);
